import { render, staticRenderFns } from "./PurchasesCardTable.vue?vue&type=template&id=3269fc9e&scoped=true"
import script from "./PurchasesCardTable.vue?vue&type=script&lang=js"
export * from "./PurchasesCardTable.vue?vue&type=script&lang=js"
import style0 from "./PurchasesCardTable.vue?vue&type=style&index=0&id=3269fc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3269fc9e",
  null
  
)

export default component.exports